import jwt_decode from 'jwt-decode';

export const extrairDadosToken = token=> {
    try {
        return jwt_decode(token);
    } catch (error) {
        console.log('Erro ao decodificar o token:', error);
        throw new Error({
            status: 400,
            message: 'Invalid Token.'
        });
    }
};